export default __webpack_public_path__ + "static/media/icon-quantity.1c97ac42.svg";